import React, { useContext } from "react";
import { ThemeContext } from "../../container/mppmodal/MppInfo";

const mppModalHeader = (props) => {
  const {
    isWideWrapper,
    brandings: { bannerImage, bannerAltText, mppPrimaryColors },
    merchantName,
    merchantWebsiteURL,
    mppFromEmail,
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = useContext(ThemeContext);

  const {msfPrimaryColors} = props;

  return (
    <React.Fragment>
      <div
        className="modal-header" role="header"
        style={{ borderColor: msfPrimaryColors? msfPrimaryColors: mppPrimaryColors }}
      >

        {mppFromEmail ? (
          <div className={"modal-title h4"}>
            <div className="float-left zetailImgDiv">
              <a href={merchantWebsiteURL} target="_blank" className="zetailimg" rel="noreferrer">
                <img
                  src={bannerImage}
                  className="zetailimg"
                  alt={merchantName}
                  title={merchantName}
                  tabIndex="0"
                />
              </a>
            </div>
          </div>
        ) : (
          <div className={"modal-title h4"}>
            <div className="float-left zetailImgDiv">
              <img
                src={bannerImage}
                className="zetailimg"
                alt={merchantName}
                title={merchantName}
              />
            </div>
          </div>
        )
        }
      </div>
    </React.Fragment>
  );
};
export default mppModalHeader;
